import app from 'flarum/forum/app';
import LoadingDependenciesModal from '../modals/LoadingDependenciesModal';

export default function (componentClass: any, attrs: any): void {
    // @ts-ignore accessing global variable to know if loaded or not
    if (window.fabric) {
        // We don't absolutely need to require the Flarum version with stackable modals
        // If Flarum version is older, this simply won't have any effect and you can still resume by re-opening the modal
        app.modal.show(componentClass, attrs, true);
    } else {
        app.modal.show(LoadingDependenciesModal, {}, true);

        const script = document.createElement('script');
        script.crossOrigin = 'anonymous';
        script.integrity = 'sha256-ci3ufCFiOsHDyOz3khAAeNZdBAxy/NqCeHZ1M6kyiP4=';
        script.src = 'https://cdn.jsdelivr.net/npm/fabric@4.6.0/dist/fabric.min.js';
        script.onload = () => {
            // Remove middle handles from circle controls since this seems to be the only way to prevent changing the aspect ratio
            // Also remove the rotation handle since it's otherwise always in disabled state
            (() => {
                const {ml, mr, mb, mt, mtr, ...originalCircleControls} = fabric.Circle.prototype.controls;
                fabric.Circle.prototype.controls = originalCircleControls;
            })();
            // Similar to circle. Use anonymous method to create new scope for variables of same name
            (() => {
                const {ml, mr, mb, mt, ...originalImageControls} = fabric.Image.prototype.controls;
                fabric.Image.prototype.controls = originalImageControls;
            })();

            // Close loading modal without triggering any redraw since we know we'll be opening a new modal right after this
            if (Array.isArray(app.modal.modalList) && app.modal.modalList.length && app.modal.modalList[app.modal.modalList.length - 1].componentClass === LoadingDependenciesModal) {
                app.modal.modalList.pop();
            }

            app.modal.show(componentClass, attrs, true);
        };
        document.body.appendChild(script);
    }
}
